<template>
    <div class="line-box">
        <div class="title">
            <p>搜索热词</p>
            <span>热词最多20个词，鼠标拖拽左侧圆点可调整</span>
        </div>
        <div class="input-box">
            <draggable  class="dragArea list-group" v-model="configData.list" item-key="id">
                <template v-for="(element, index) in configData.list">
                    <div class="input-item" :key="index">
                        <div class="icon">
                            <el-icon class="iconfont el-icon-_nav"></el-icon>
                        </div>
                        <el-input v-model="element.val" maxlength="10" placeholder="选填，不超过十个字"  />
                        <div class="delete" @click.stop="bindDelete(index)">
                            <el-icon class="iconfont icondel_1" size="20"></el-icon>
                        </div>
                    </div>
                </template>
            </draggable>
            <div class="add-btn" @click="addTxt" v-if="configData.list.length < configData.max">
                <el-button ghost style="width: 100%; height: 40px;border-color:#1890FF; color: #1890FF;">添加热词</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    export default {
        name: "words",
        components: {
            draggable,
        },
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        methods: {
            addTxt () {
                let obj = {
                    val: ''
                };
                this.configData.list.push(obj)
            },
            // 删除数组
            bindDelete (index) {
                this.configData.list.splice(index, 1)
            },
        }
    }
</script>

<style scoped lang="less">
    .line-box {
        margin-top: 20px;
        padding: 10px 0 20px;
        border-top: 1px solid rgba(0,0,0,.05);
        border-bottom: 1px solid rgba(0,0,0,.05);
        .title{
            p{
                font-size: 14px;
                color: #000000;
            }
            span {
                color: #999999;
            }
        }
        .input-box {
            margin-top: 10px;
            .add-btn {
                margin-top: 18px;
            }
            .input-item {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                position: relative;
                delete{
                    position: absolute;
                    right: -7px;
                    top: -8px;
                    color: #999;
                }
                .icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 36px;
                    cursor: move;
                }
            }
        }
    }
</style>
